import { render, staticRenderFns } from "./ExamResults.vue?vue&type=template&id=180b6f13"
import script from "./ExamResults.vue?vue&type=script&lang=js"
export * from "./ExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180b6f13')) {
      api.createRecord('180b6f13', component.options)
    } else {
      api.reload('180b6f13', component.options)
    }
    module.hot.accept("./ExamResults.vue?vue&type=template&id=180b6f13", function () {
      api.rerender('180b6f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/exam/ExamResults.vue"
export default component.exports